import React from 'react';
import NoteSticky from '../Icons/NoteSticky'
import House from '../Icons/House'
import Bell from '../Icons/Bell'
import Clipboard from '../Icons/Clipboard'

class PropertyCalendarToggles extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='PropertyCalendarToggles'>
        <label>
          <input
            type='checkbox'
            name='show_notes'
            checked={this.props.show_notes}
            onChange={this.props.onChangeToggle}
          />{' '}
          <NoteSticky /> {I18n.t('notes')}
        </label>
        <label>
          <input
            type='checkbox'
            name='show_notifications'
            checked={this.props.show_notifications}
            onChange={this.props.onChangeToggle}
          />{' '}
          <Bell /> {I18n.t('notifications')}
        </label>
        <label>
          <input
            type='checkbox'
            name='show_service_logs'
            checked={this.props.show_service_logs}
            onChange={this.props.onChangeToggle}
          />{' '}
          <Clipboard /> {I18n.t('service_requests')}
        </label>
        <label>
          <input
            type='checkbox'
            name='show_housekeeping'
            checked={this.props.show_housekeeping}
            onChange={this.props.onChangeToggle}
          />{' '}
          <House /> {I18n.t('housekeeping')}
        </label>
      </div>
    );
  }
}

export default PropertyCalendarToggles;